<template>
  <div id="nav">
    <el-menu
      style="box-shadow: 0 0 5px 1px #aaaaaa; border-bottom: 0"
      class="el-menu-demo"
      mode="horizontal"
      :default-active="getMainPath()"
      >
      <el-menu-item>
        <img alt="Contract Manager logo" src="../assets/contract-logo.png" height="40px">
      </el-menu-item>
      <el-menu-item @click="onMenuClick('home')" index="/" style="display: none;">{{ $t('home') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('hotel')" index="/hotel" >{{ $t('hotel') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('agent')" index="/agent" >{{ $t('agent') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('contract')" index="/contract" >{{ $t('contract') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('specialOffer')" index="/special-offer" >{{ $t('specialOffer') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('email')" index="/email" >{{ $t('email') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('setting')" index="/setting" >{{ $t('setting') }}</el-menu-item>
      <el-menu-item @click="onMenuClick('user')" index="/user" >{{ $t('user') }}</el-menu-item>
      <el-menu-item class="logout-menu">
        <el-button type="default"
                   size="small"
                   @click="onLogoutButtonClick">
          <font-awesome-icon icon="sign-out-alt" />
          Logout
        </el-button>
      </el-menu-item>
      <div class="div-username">{{getUsername()}}</div>
      <el-submenu index="4" style="float: right;">
        <template slot="title">{{ getCurrentLang() }}</template>
        <el-menu-item @click="changeLang('en')">EN</el-menu-item>
        <el-menu-item @click="changeLang('th')">ไทย</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { get } from 'lodash'
import i18n from '@/i18n'
import i18nMessages from '@/translations/template/HeaderTemplate.i18n'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { COMPANY_TYPE, VUEX_EVENT } from '@/configs/constant'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import PubSub from '@/pubsub'
import HotelApi from '@/api/hotel-api'

library.add(faSignOutAlt)

export default {
  name: 'HeaderTemplate',
  components: { FontAwesomeIcon },
  i18n: { messages: i18nMessages },
  methods: {
    changeLang: function (lang) {
      i18n.locale = lang
    },
    getMainPath: function () {
      const mainPath = this.$route.path.split('/')[1]

      return `/${mainPath}`
    },
    _getHotelRouterName: async function () {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      let routerName = 'HotelList'

      if (companyDetail.companyType === COMPANY_TYPE.STANDALONE) {
        const hotelList = await HotelApi.list()
        const hotel = hotelList[0]
        await this.$store.dispatch(VUEX_EVENT.GENERAL.SET_ACTIVE_HOTEL_ID, hotel.id)
        await this.$store.dispatch(VUEX_EVENT.GENERAL.SET_HOTEL_LIST, hotelList)

        routerName = 'HotelInfo'
      }

      return routerName
    },
    onMenuClick: async function (menuName) {
      let routerName = ''

      switch (menuName) {
        case 'hotel':
          routerName = await this._getHotelRouterName()
          break
        case 'home':
          routerName = 'Home'
          break
        case 'user':
          routerName = 'UserList'
          break
        case 'agent':
          routerName = 'AgentList'
          this.$store.dispatch(VUEX_EVENT.CONTRACT.CLEAR_MAP_STATE_CONTRACT_LIST)
          break
        case 'contract':
          routerName = 'ContractList'
          this.$store.dispatch(VUEX_EVENT.CONTRACT.CLEAR_MAP_STATE_CONTRACT_LIST)
          break
        case 'specialOffer':
          routerName = 'SpecialOfferList'
          this.$store.dispatch(VUEX_EVENT.SPECIAL_OFFER.CLEAR_MAP_STATE_SPECIAL_OFFER_LIST)
          break
        case 'email':
          routerName = 'EmailGeneral'
          break
        case 'setting':
          routerName = 'SettingGeneral'
          break
      }

      this.$router.push({
        name: routerName
      })
    },
    getCurrentLang: function () {
      return i18n.locale.toUpperCase()
    },
    getUsername: function () {
      const userDetail = LocalStorageFactory.getUserDetail()
      const username = get(userDetail, 'username', '')

      return username
    },
    onLogoutButtonClick: function () {
      PubSub.publish(PubSub.EVENT.UNAUTHORIZED)
    }
  }
}
</script>
<style scoped>
  #nav{
    position: sticky;
    top: 0px;
    z-index: 1;
  }
  .div-username {
    float: right;
    padding-top: 20px;
    font-size: 14px;
  }
  .div-username:focus {
    outline: none;
  }

  .logout-menu {
    float: right !important;
  }
</style>
